export default "/stationCluster1.png"